import { render, staticRenderFns } from "./DocsViewer.vue?vue&type=template&id=3c82929c&"
import script from "./DocsViewer.vue?vue&type=script&lang=js&"
export * from "./DocsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports